import React, { useState } from 'react';

import { BulkSubstitutionRuleUpload } from 'components/fbm/substitutions/BulkSubstitutionRuleUpload';
import { ViewSubstitutionRuleEvents } from 'components/fbm/substitutions/ViewSubstitutionRuleEvents';
import { ViewSubstitutionRules } from 'components/fbm/substitutions/ViewSubstitutionRules';
import { Card } from 'shadcn/components/ui/Card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shadcn/components/ui/Tabs';
import { FBMAccountPicker } from 'shared';

function FBMSubstitutionRules() {
    const [selectedTab, setSelectedTab] = useState('0');

    return (
        <Card className="p-6">
            <FBMAccountPicker />
            <Tabs value={selectedTab} onValueChange={setSelectedTab} className="w-full">
                <div className="flex justify-center border-b border-border text-left">
                    <TabsList className="rounded-none bg-transparent p-0">
                        <TabsTrigger
                            id="ViewFBMSubstitutionRules_Tab"
                            value="0"
                            className="rounded-none px-4 py-2 data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                        >
                            View
                        </TabsTrigger>
                        <TabsTrigger
                            id="BulkFBMSubstitutionRules_Tab"
                            value="1"
                            className="rounded-none px-4 py-2 data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                        >
                            Bulk Upload
                        </TabsTrigger>
                        <TabsTrigger
                            id="EventLogFBMSubstitutionRules_Tab"
                            value="2"
                            className="rounded-none px-4 py-2 data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                        >
                            Event Log
                        </TabsTrigger>
                    </TabsList>
                </div>
                <TabsContent value="0" className="mt-0">
                    <ViewSubstitutionRules />
                </TabsContent>
                <TabsContent value="1" className="mt-0">
                    <BulkSubstitutionRuleUpload />
                </TabsContent>
                <TabsContent value="2" className="mt-0">
                    <ViewSubstitutionRuleEvents />
                </TabsContent>
            </Tabs>
        </Card>
    );
}

export { FBMSubstitutionRules };
